import { useEffect } from 'react';

import { useUIContext } from 'hb-react/frontoffice/contexts/UIContext';

export const useDisableBottomLinksAccordion = () => {
  const { setIsBottomLinksAccordionVisible } = useUIContext();

  useEffect(() => {
    setIsBottomLinksAccordionVisible(false);

    return () => setIsBottomLinksAccordionVisible(true);
  }, [setIsBottomLinksAccordionVisible]);
};
